import {shopUtilities} from "@global/shop-utilities/shop-utilities";

export const actions = {
    login: ({ commit }) => {
        if (window.PFL_AUTHENTICATED !== undefined) {
            commit('authenticated', window.PFL_AUTHENTICATED);
        }
    },
    logout: ({ commit }) => {
        commit('authenticated', false)
    },
    setFreeze: ({ commit }, freeze) => {
        commit('setFreeze', freeze);
    },
    setCartData: ({ commit }, cartData) => {
        commit('setCartData', cartData)
    },
    removeCartItemFromCartData: ({ commit }, pim_id) => {
        commit('removeCartItemFromCartData', pim_id)
    },
    setCartFanboxList: ({ commit }, list) => {
        commit('setCartFanboxList', list.split(','))
    },
    setCartFanboxItems: ({ commit }, items) => {
        commit('setCartFanboxItems', items)
    },
    setCartSelectFanbox: ({ commit }, payload) => {
        if (typeof payload === 'boolean') {
            commit('setCartSelectFanbox', payload)
        } else {
            console.error("Could not set selectFanbox state. Expected boolean.");
        }
    },
    setCartFanboxThreshold: ({ commit }, payload) => {
        commit('setCartFanboxThreshold', payload)
    },
    addCartErrorItem({ commit }, pim_id) {
        commit('addCartErrorItem', pim_id)
    },
    removeCartErrorItem({ commit }, pim_id) {
        commit('removeCartErrorItem', pim_id)
    },
    removeCartOrderQuantity({ commit }, pim_id) {
        // TODO: remove from cart data

        shopUtilities.changeQuantity('cart', pim_id, 0)

        commit('removeCartOrderQuantity', pim_id)
    },
    changeCartOrderQuantity({ commit, getters }, payload) {
        if(payload.quantity > 1) {
            shopUtilities.changeQuantity('cart', payload.pim_id, payload.quantity)
        } else {
            shopUtilities.changeQuantity('cart', payload.pim_id, 0)
        }

        if(payload.quantity === 0) {
            const itemData = getters.cartGetCartDataItemForPimId(payload.pim_id)

            shopUtilities.remove('cart', itemData.order_pid, {
                id: itemData.order_pid,
                title: itemData.title,
                subtitle: itemData.subtitle,
                subsubtitle: itemData.subsubtitle
            })
            commit('removeCartItemFromCartData', itemData.pim_id);
        }

        commit('changeCartOrderQuantity', {pim_id: payload.pim_id, quantity: payload.quantity})
    },
};
